const teams = [
  // {
  //   id: 1,
  //   imageUrl: "/assets/img/avatars/avatar2.jpg",
  //   name: "Dr.Sanjay Gupta",
  //   // designation: "IT Expert",
  // },
  // {
  //   id: 2,
  //   imageUrl: "/assets/img/avatars/avatar1.jpg",
  //   name: "Dr . Sowmya",
  //   // designation: "Web Designer",
  // },
  {
    id: 3,
    imageUrl: "/assets/img/avatars/avatar3.jpg",
    name: "Sabeer",
    // designation: "Content Writer",
  },
  {
    id: 4,
    imageUrl: "/assets/img/avatars/avatar4.jpg",
    name: "Madhulatha",
    // designation: "Marketing officer",
  },
];
export {
    teams
}




